import { useEffect } from 'react';

function PromotionCenter() {
  useEffect(() => {
    window.location.replace('/promotion.html');
  }, []);

  return null;
}

export default PromotionCenter;
